import React from 'react';
import { Chip as MUIChip } from '@mui/material';
import { cx } from '@emotion/css';
import { useStyles } from './Chip.styles';
export function Chip({ label, className, id, variant = 'filled', color = 'default', disabled, clickable, onClick, }) {
    const classes = useStyles();
    return (React.createElement(MUIChip, { className: cx(className, classes.root), id: id, label: label, color: color, variant: variant, clickable: clickable, disabled: disabled, onClick: onClick }));
}
//# sourceMappingURL=Chip.js.map